import { render } from "./NcrmDataIntegrations.vue?vue&type=template&id=621052b4&scoped=true"
import script from "./NcrmDataIntegrations.vue?vue&type=script&lang=js"
export * from "./NcrmDataIntegrations.vue?vue&type=script&lang=js"

import "./NcrmDataIntegrations.vue?vue&type=style&index=0&id=621052b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621052b4"]])

export default __exports__